export default __webpack_public_path__ + "assets/e131cf101b7ac3638ca6901becd3f868.woff";